<template>
<div class="papsi-wrapper">
    <h1 class="text-2xl font-semibold text-[#016B00] "> Announcement Page</h1>
    <p class="text-xs text-[#747474] mt-2">Home / Announcement</p>
</div>
<div class="papsi-wrapper flex mt-7 flex-col">
    <div class="flex items-center gap-5 ">
        <h1 class="text-[#016B00] font-semibold text-lg">Search/Edit Announcement Portal</h1>
        <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Annoucement</button>
    </div>
    <div class="papsi-container w-[100%]">
        <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
            <TableControl :Action="true" :header="header" :column="column" :info="info" :EButton="true" :DButton="true" @EditButton="EditButton" @DeleteButton="DeleteButton"/>
        </div>
    </div> 
</div>
<div v-if="addAnc">
    <div @click="addAnc = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
    </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-[#016B00] py-3 px-6 ">
                    <p class="text-[#ffffff] text-md font-semibold">{{ type }}</p>
                </div>
                <div class="pafcpic_body py-6 px-6">
                    <div class="bg-[#bdb9b9] w-full h-[180px] mb-3 flex justify-center items-center"><img class=" object-cover h-full" :src="image"></div>
                    <!-- <p class="text-xs text-[#fd4444] ">{{ ErrorTitle }}</p> -->
                    <input type="text"  v-model="Title" placeholder="Title" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none mb-3">
                    <!-- <p class="text-xs text-[#fd4444]  mt-3">{{ ErrorCaption}}</p> -->
                    <textarea  v-model="Caption" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none resize-none" rows="5" placeholder="What's on your mind?"></textarea>
                    <p class="text-xs text-[#868585]  mt-1 font-medium">Upload Image</p>
                    <input type="file" @change="onFileChange" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#afb1af] font-semibold w-full outline-none">
                </div>
                
                <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t font-medium">
                    <button class="text-sm text-white bg-[#016B00] py-1.5 px-7 rounded-md w-[100px] text-center" v-if="EditorAdd === 'Edit'" @click="editAnnouncement">Update</button>
                    <button class="text-sm text-white bg-[#016B00] py-1.5 px-7 rounded-md w-[100px] text-center"  v-if="EditorAdd === 'Add'" @click="AddAnnoucement">Add</button>
                    <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="addAnc = false">Cancel</button>
                </div>
            </div>
        </div>
</div>

<ValidPrompt v-if="validation" @yes="confirmedDelete" @cancel="cancelValidation" :header="promtHead" :header1="promtBody" />

<div v-if="Delete">
    <Prompt type="DELETE" @close="Delete = false"/>
</div>


<div v-if="Success">
    <Prompt type="ADDANC" @close="Success = false"/>
</div>

<div v-if="Validation">
    <Prompt type="VALIDATION" @close="Validation = false"/>
</div>


<div v-if="Update">
    <Prompt type="UPDATEANC" @close="Update = false"/>
</div>
</template>

<script>
import { defineComponent } from 'vue';
import TableControl from '@/components/controls/TableControl/TableControl.vue'
import Services from './../../services/admin'
import Prompt from './Prompt/RequestPromt.vue'
import ValidPrompt from './Prompt/ValidationPrompt.vue'

export default defineComponent ({
    components:{
        TableControl,
        ValidPrompt,
        Prompt
    },
    data(){
        return{
            promtHead:null,
            promtBody:null,
            validation:false,
            type:'',
            Update:         false,
            Delete:         false,
            Success:        false,
            Validation:     false,
            EditorAdd:      null,
            addAnc:         false,
            info:           null,
            TableView:      true,
            AddResponse:    '',
            Title:          '',
            Caption:        '',
            ErrorTitle:     '',
            ErrorCaption:   '',
            updateid:       null,
            file:           '',
            image:'',
            feed_code:null,
            header:[
                {
                title:'Reference No.'
                },
                {
                title:'Title'
                },
                {
                title:'Date Published'
                },
                {
                title:'Action'
                },
            ],
            column:[
                'feed_code',
                'title',
                'date',
            ]
        }
    },
    mounted(){
        this.GetAnnoucement()
    },
    methods:{
        cancelValidation(){
            this.validation = false
        },
        onFileChange(e){
            this.file = e.target.files[0];
        },
        EditButton(row){
            this.image     = null
            this.type      = 'UPDATE ANNOUNCEMENT'
            this.result    = ''
            this.EditorAdd = 'Edit'
            this.updateid  =  row.id
            this.addAnc    =  true
            this.Title     =  row.title
            this.Caption   =  row.caption
            this.feed_code = row.feed_code
            this.getImage(row.feed_code)
        },
        async getImage(feed_code){
     
            const success = await Services.getImage(feed_code);
            this.image = "data:image/jpeg;base64," +  success.data[0].ffeeds_source
        },
         DeleteButton(row){
            this.AncData        = row
            this.promtHead      = "DELETE ANNOUNCEMENT"
            this.promtBody      = "Are you sure you want to delete this "+ row.title +" published on " + row.date;
            this.validation     = true
        },
        async confirmedDelete(){
            this.validation     = false
            this.$emit("showLoader")
            const success       = await Services.deleteAnnouncement(this.AncData.feed_code);
            this.AddResponse    = success.data
            this.Delete         = true
            this.GetAnnoucement()
            this.$emit("hideLoader")
        },
        HideView(){
            this.type      = 'ADD ANNOUNCEMENT'
            this.Title     =  ''
            this.Caption   =  ''
            this.result    =  ''
            this.EditorAdd =  'Add'
            if (!this.TableView){
                this.addAnc = false
            }
            else{
                this.addAnc = true
            }
        },
        async AddAnnoucement(){
            if(this.Title === '')
            {
                this.ErrorTitle = 'Title Field is Empty'
            }
            else{
                this.ErrorTitle = ''
            }
            if(this.Caption === '')
            {
                this.ErrorCaption = 'Caption Field is Empty'
            }
            else{
                this.ErrorCaption = ''
            }
            if(this.Title !='' && this.Caption !=''){
                this.$emit("showLoader")
                const success = await Services.addAnnouncement(this.Title,this.Caption,this.file);
                this.AddResponse = success.data
                this.addAnc = false
                this.Success =  true
                this.GetAnnoucement()
                this.$emit("hideLoader")
            }
            else{
                this.Validation = true
            }
        },
        async GetAnnoucement(){
            this.$emit("showLoader")
            const success = await Services.getAnnouncement();
            this.info = success.data
            this.$emit("hideLoader")
        },
        async editAnnouncement(){
            this.$emit("showLoader")
            const success = await Services.editAnnouncement(this.feed_code,this.Title,this.Caption,this.file);
            if(success.success == true){
                this.GetAnnoucement()
                this.addAnc    =  false
                this.$emit("hideLoader")
                this.Update = true
            } 
           
        }
     },
})
</script>

<style scoped>
.error{
    border:1px solid red;
}

.errorResult{
 background-color:red;
}
</style>
